import { UAParser } from 'ua-parser-js';
import { DataHubStore } from '../dataHubStore';
export class BaseSchema {
    constructor() {
        Object.defineProperty(this, "sessionId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "clubVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "url", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "screenName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platform", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platformDetail", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "appVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "osVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ucode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userRole", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "membershipId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "membershipSlug", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isLogged", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        const uaParser = new UAParser(navigator.userAgent);
        const browserInfo = uaParser.getBrowser();
        this.clubVersion = 'MEMBERSHIP';
        this.url = window.location.href;
        this.screenName = 'NOT_APP_EVENT';
        this.platform = 'WEB';
        this.platformDetail = browserInfo.name ?? '';
        this.appVersion = process.env.PROJECT_VERSION;
        this.osVersion = browserInfo.version ?? '';
        this.ucode = DataHubStore.getUcode();
        this.sessionId = DataHubStore.getSessionId();
        this.userId = DataHubStore.getMarketplaceId();
        this.userRole = 'OWNER';
        this.membershipId = DataHubStore.getMembershipId();
        this.membershipSlug = DataHubStore.getMembershipSlug();
        this.isLogged = true;
    }
    prepare() {
        return {
            sessionId: this.sessionId,
            clubVersion: this.clubVersion,
            url: this.url,
            screenName: this.screenName,
            platform: this.platform,
            platformDetail: this.platformDetail,
            appVersion: this.appVersion,
            osVersion: this.osVersion,
            ucode: this.ucode,
            userId: this.userId,
            userRole: this.userRole,
            membershipId: this.membershipId,
            membershipSlug: this.membershipSlug,
            isLogged: this.isLogged
        };
    }
}
